export function getHumanReadablePriorityTextByValue(priority: number): string {
  switch (priority) {
    case 1:
      return 'Низкий';
    case 2:
      return 'Средний';
    case 3:
      return 'Высокий';
    default:
      return '---';
  }
}
